// 配置全局接口域名

//const domain = 'http://127.0.0.1:8083/';
const domain = 'http://47.104.81.91:8083/';
//const domain = 'http://192.168.2.253:8083/';
//const domain = 'http://47.92.140.26:8083/';

export default {

  apiUrl:domain

}


// WEBPACK FOOTER //
// ./src/domain.js